module.exports = __webpack_public_path__ + "img/home2.94396224.jpg";